import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import 'rxjs/add/observable/of';
import { FormControl, Validators } from '@angular/forms';
import { DialogService } from './../../../shared/services/dialog.service';
import { Utility } from './../../../common/utility';
import { AppMessages } from './../../../shared/constants/messages';
import { AppConstants } from './../../../shared/constants/constants';
import { Page } from './../../../models/list/page.model';
import { Observable } from 'rxjs/Observable';
import { ResultSearchPatientService } from './result-search-patient.service';
import { SelectClinicPopupComponent } from '../../select-clinic/select-clinic-popup.component';
import { ConsultationHistoryComponent } from '../../consultation-history/consultation-history.component';
import { TMBDataTableComponent } from '../../../components/data-table/data-table.component';
import { SharedService } from '../../../shared/services/share.services';

@Component({
    selector: 'result-search-patient',
    templateUrl: 'result-search-patient.component.html',
    providers: [ResultSearchPatientService]
})
export class ResultSearchPatientComponent extends TMBDataTableComponent implements OnInit {
    public isBaseClinic = localStorage.getItem(AppConstants.localStorage.isBaseClinic) == 'true';
    public filterParam;
    public isNoResult = true;

    constructor(
        public utility: Utility,
        private activeRouter: ActivatedRoute,
        private router: Router,
        public dialogService: DialogService,
        public sharedService: SharedService,
        private resultSearchPatientService: ResultSearchPatientService
    ) { super(sharedService); }


    ngOnInit() {
        this.filterParam = {
            reference: this.activeRouter.snapshot.queryParams['reference'],
            name: this.activeRouter.snapshot.queryParams['name'],
            userName: this.activeRouter.snapshot.queryParams['userName'],
            address: this.activeRouter.snapshot.queryParams['address'],
            email: this.activeRouter.snapshot.queryParams['email'],
            dateofBirth: this.activeRouter.snapshot.queryParams['dateOfBirth'],
            gender: this.activeRouter.snapshot.queryParams['genderId'],
            organizationId: this.activeRouter.snapshot.queryParams['organizationId']
        };
        this.page.size = 30;
        this.setPage({ offset: 0 });
    }



    onBackSearchPatient() {
        this.router.navigate(['/consultation/search-patient']);
    }

    setPage(pageInfo) {
        this.page.pageNumber = pageInfo.offset;
        // temporary bind data

        const param = {
            pageSize: this.page.size,
            currentPage: this.page.pageNumber + 1,
            reference: this.filterParam.reference,
            name: this.filterParam.name,
            userName: this.filterParam.userName,
            address: this.filterParam.address,
            email: this.filterParam.email,
            dateOfBirth: this.filterParam.dateofBirth,
            gender: this.filterParam.gender,
            organizationId: this.filterParam.organizationId
        };
        // push our inital complete list
        this.resultSearchPatientService.getPatientList(param).subscribe(
            (result) => {
                if (result) {
                    this.dataRow = result.json();
                    if (this.dataRow.length > 0) {
                        this.isNoResult = false;
                        this.page.totalElements = this.dataRow[0].totalRecord;
                        this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);
                    }
                }
            }
        );
    }

    onLinkPatient() {

    }


    /**
     * add patient back to waiting room
     * @param string id : patient ID
     */
    onReturnWaitingRoom(id: string) {
        this.dialogService.openComponentDialog(SelectClinicPopupComponent).subscribe(result => {
            // user select clinic  result = clinicId
            if (result.isSuccess) {
                const clinicId = result.id;
                this.resultSearchPatientService.addPatientToWaitingRoom(id, clinicId).subscribe(
                    (addResult) => {
                        if (addResult) {
                            // redirect to waiting room
                            this.router.navigate(['/consultation/waiting-room']);
                            this.dialogService.openSuccessDialog({ message: AppMessages.waitingRoom.addPatientSuccess });
                        }
                    }
                );
            }

        });
    }

    onViewItem(id: string) {
        this.router.navigate(['centre/patient-information', id]);
    }

    onOpenConsultationHistory(id: string) {
        const height = window.screen.height - (window.screen.height * 30 / 100);
        const width = window.screen.width - (window.screen.width * 20 / 100);
        const data = {
            patientId: id,
            height: height,
            width: width
        };
        this.dialogService.openComponentDialog(ConsultationHistoryComponent, data, {
            width: '80%',
            height: '810px'
        });
    }

    onOpenAccountPayment(id: string) {
        this.router.navigate(['payment/account-payment'],
            {
                queryParams:
                    {
                        patientId: id,
                    }
            });
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/result-search-patient/result-search-patient.component.ts